import { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

import { useGetDashboardGamesNotUpdatedQuery } from '../../../../api/dashboard'
import { filterRowsByName, toGameRow } from '../../helpers/dashboardHelpers'
import { DashboardAction, DashboardColumn, DashboardListDialogProps } from '../../types/Dashboard'
import { DashboardGamesDialog } from '../DashboardGamesDialog/DashboardGamesDialog'
import { DashboardGamesTable } from '../DashboardGamesTable/DashboardGamesTable'

const columns = [DashboardColumn.Icon, DashboardColumn.Name, DashboardColumn.Publisher, DashboardColumn.Powerscore]
// Legacy's edit and edit review buttons here call functions it never passes in.
const actions = [DashboardAction.ViewAnalyses]

export const NotUpdatedGamesDialog: FC<DashboardListDialogProps> = ({ open, marketIso, onClose, onAction, storedSubgenres }) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  useEffect(() => setSearch(''), [open])

  const gamesQuery = useGetDashboardGamesNotUpdatedQuery(marketIso, { skip: !open, refetchOnMountOrArgChange: true })
  const rows = useMemo(() => (gamesQuery.data ?? []).map((game) => toGameRow(game, marketIso)), [gamesQuery.data, marketIso])
  const shownRows = useMemo(() => filterRowsByName(rows, search), [rows, search])

  return (
    <DashboardGamesDialog
      open={open}
      title={t('internal-analysts:dashboard_not_updated_title')}
      onClose={onClose}
      search={search}
      onSearchChange={setSearch}
      isLoading={gamesQuery.isFetching}
      error={gamesQuery.isError ? t('internal-analysts:dashboard_list_failed') : undefined}
      summary={<Typography>{t('internal-analysts:dashboard_games_count', { count: rows.length })}</Typography>}
    >
      <DashboardGamesTable
        rows={shownRows}
        columns={columns}
        actions={actions}
        onAction={onAction}
        storedSubgenres={storedSubgenres}
        noRowsLabel={t('internal-analysts:dashboard_no_games')}
      />
    </DashboardGamesDialog>
  )
}
